import Vue from 'vue';

import { stringify } from 'querystring';

const storePrefix = "manage_store_";

const state = {

    sessionStorageKey: "ss_ManageReport",

    ManageData: null,

    ManageTime: {
        from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
        to: new Date(),
        period: null
    }
}

const getters = {

    getManageData(state) {
        return state.ManageData;
    },
    getManageTime(state) {
        return state.ManageTime;
    },

}

const mutations = {


    [`${storePrefix}updateManageData`](state, payload) {
        state.ManageData = payload;
    },

}

const actions = {

    fetchManageData(context) {

        let dateRange = context.getters.getManageTime;

        return new Promise((resolve, reject) => {

            var payload = {
                from: dateRange.from.getTime(),
                to: dateRange.to.getTime()
            };

            Vue.$http.post("/api/manageapi/GetManageData", payload).then((response) => {

                let responseData = response.data;

                if (responseData) {

                    context.commit(`${storePrefix}updateManageData`, responseData);

                }

                resolve();

            }).catch((error) => {
                reject();
            });

        });

    },


}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/Manage/store/manage.js